import Grid from '@mui/material/Grid';
import BaseTable from 'components/Tables/BaseTable';
import { actions as actionsAccounts } from 'ducks/accounts';
import { alertError } from 'ducks/alerts';
import React from 'react';
import { connect } from 'react-redux';
import { currentAccount, currentUser } from 'selectors/currentUser';

const columns = suppliersById => [
  { title: 'Conta cliente', field: 'name' },
  { title: 'NIF', field: 'vat_number' },
  { title: 'Morada', field: 'address' },
  {
    title: 'Fabricante ID / Fornecedor',
    field: 'supplier_id',
    editable: 'never',
    render: rowData => rowData.supplier_id ? suppliersById[rowData.supplier_id].name : ''
  },
];

const Component = props => {
  const { account, suppliersById, user } = props;
  const { updateAccount } = props;

  return (
    <Grid size={12}>
      <BaseTable
        columns={columns(suppliersById)}
        data={[account]}
        options={{
          search: false,
          toolbar: false,
          maxBodyHeight: null,
          minBodyHeight: null,
          pageSize: 5
        }}
        editable={
          // Everyone reaches this page from the menu, but only staff may edit the
          // account now - without this the rest would get a raw alert from the 403.
          user.superuser ? {
            // No re-fetch afterwards. `updateAccount` writes through the accounts
            // duck, so the store this screen reads is the one that was just
            // updated - the `.then(() => fetchUserAccount())` existed only to
            // refresh a second copy of the row, and there is no second copy now.
            onRowUpdate: (newData, oldData) => updateAccount(newData.id, newData)
          } : undefined
        }
      />
    </Grid>
  );
};


const mapStateToProps = state => ({
  // The caller's own row, out of the scoped `/accounts/` collection. It used
  // to come from a separate `/user_account/` fetch holding a second copy.
  account: currentAccount(state),
  suppliersById: state.suppliers.models,
  user: currentUser(state)
});

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  updateAccount: (id, data) => dispatch(actionsAccounts.updatePromise(id, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
